module.exports = __webpack_public_path__ + "media/images/workplace/intro-page/step2-1-p-1433398df5cb8e500bb577a328ee07bc.gif";